import { FinancialAccountSortOption } from '@rematter/frontend-lib-api-client';

import { ObjectRefRecord } from '~/shared/components/custom-attributes/types';
import { createQueryHook } from '~/shared/providers/api';

export const useFinancialAccountsQuery = createQueryHook(
  'finance.financialAccounts',
  (params: {
    searchTerm?: string;
    sorting?: FinancialAccountSortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    financialAccounts: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
      },
    },
  }),
  {
    select: (data): ObjectRefRecord[] =>
      data?.financialAccounts.entries.map((account) => ({
        id: account.id,
        name: account.name,
      })) ?? [],
  },
);
